import React, { memo } from "react"
import { DragSourceMonitor, useDrag } from "react-dnd"
import { GuestSummary, ItemTypes, Table } from "sharedTypes"
import {
  GuestRow, GuestRowBody, GuestRowPerson, GuestRowSeat,
} from "components/GuestList/GuestRow"

type Props = {
  guest: GuestSummary
  order: string
  plusOne: boolean
  canEditSeating: boolean
  onDropOnSeat: (guest: GuestSummary, table: Table, seatNumber: number) => void
}

type DropResult = { table: Table, seatNumber: number }

/** A guest on the Seating page, dragged onto a seat when seating can be edited. */
const GuestListItem = ({
  guest, order, plusOne, canEditSeating, onDropOnSeat,
}: Props) => {
  const [{ isDragging }, drag, dragPreview] = useDrag({
    type: ItemTypes.GUEST,
    canDrag: canEditSeating,
    item: { type: ItemTypes.GUEST },
    collect: (monitor) => ({ isDragging: monitor.isDragging() }),
    end: (_, monitor: DragSourceMonitor<{ type: typeof ItemTypes }, DropResult>) => {
      if (!monitor.didDrop()) return

      const { table, seatNumber } = monitor.getDropResult()!
      onDropOnSeat(guest, table, seatNumber)
    },
  })

  return (
    <GuestRow seated={!!guest.seatingAssignment} dragging={isDragging}>
      <GuestRowBody
        ref={canEditSeating ? drag : undefined}
        cursor={canEditSeating ? "move" : undefined}
        plusOne={plusOne}
      >
        <GuestRowPerson ref={dragPreview} guest={guest} order={order} />
      </GuestRowBody>
      {guest.seatingAssignment && <GuestRowSeat {...guest.seatingAssignment} />}
    </GuestRow>
  )
}

export default memo(GuestListItem)
